import React from 'react';
import PropTypes from 'prop-types';
import { ApplianceFuelType } from '@thd-olt-component-react/appliance-fuel-type';
import { AttributeLabel } from '../attribute-label/attribute-label';

const { string, bool, arrayOf, shape } = PropTypes;

export const FuelType = ({
  itemId,
  fuelTypeStatus = {}
}) => {
  const {
    shouldShowHeader,
    headerName,
    headerLabel,
    drawerStatus,
    fuelTypeWillRender
  } = fuelTypeStatus || {};

  if (!fuelTypeWillRender) {
    return null;
  }

  return (
    <>
      {shouldShowHeader && (
        <AttributeLabel
          attributeName={headerName}
          attributeLabelValue={headerLabel}
        />
      )}
      <ApplianceFuelType
        itemId={itemId}
        drawerStatus={drawerStatus}
        entryType="ALERT"
        position="right"
        allowHeader
        imageCacheEnabled
      />
    </>
  );
};

FuelType.propTypes = {
  itemId: string.isRequired,
  fuelTypeStatus: shape({
    shouldShowHeader: bool,
    headerName: string,
    headerLabel: string,
    drawerStatus: shape({
      types: arrayOf(string),
      categories: arrayOf(string),
      isDryer: bool,
      isRange: bool,
      hasElectric: bool,
      hasGas: bool,
      hasInduction: bool,
      hasDualFuel: bool,
      hasHeatpump: bool
    })
  })
};

FuelType.displayName = 'FuelType';
